import { useEffect } from "@wordpress/element";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { getProducts, selectProducts } from "store/vino/productsSlice";
import { fetchCartLineItems } from "store/vino/cartSlice";
import { subscribeCartItemRemoved, unsubscribeCartItemRemoved } from "eventBus";
import ProductList from "./ProductList";
import LeftSideBar from "./LeftSideBar";
import TopTollBar from "./TopTollBar";

const ProductListContainer = () => {
	const dispatch = useDispatch();
	const products = useSelector(selectProducts);

	useEffect(() => {
		dispatch(getProducts());
	}, [dispatch]);

	useEffect(() => {
		subscribeCartItemRemoved(() => {
			dispatch(fetchCartLineItems());
		});
		return () => {
			unsubscribeCartItemRemoved();
		};
	}, [dispatch]);

	return (
		<div className="flex flex-col w-full">
			<TopTollBar />
			<div className="flex flex-nowrap">
				<div className="w-160">
					<LeftSideBar />
				</div>
				<div className="flex-1">
					<ProductList products={products} />
				</div>
			</div>
		</div>
	);
};

ProductListContainer.propTypes = {
	attributes: PropTypes.object,
};

export default ProductListContainer;
